import { render } from "./FlowPanelContentSplit.vue?vue&type=template&id=7f4c382e&scoped=true&ts=true"
import script from "./FlowPanelContentSplit.vue?vue&type=script&lang=ts"
export * from "./FlowPanelContentSplit.vue?vue&type=script&lang=ts"

import "./FlowPanelContentSplit.vue?vue&type=style&index=0&id=7f4c382e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4c382e"]])

export default __exports__